export const JOB_STATUS = {
  DRAFT: 'draft',
  IN_REVIEW: 'In review',
  IN_PROGRESS: 'in progress',
  NEW: 'New',
  READY: 'ready',
  PUBLISHED: 'published',
  DONE: 'Done',
};
